import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { ProductService } from '../../../shared/services/product.service'
import {
  buildBilledAsLanguage,
  buildHeaderBannerLanguage,
  buildPeriodCostLanguage,
  buildPlanTitle,
  getBillingPlanLabel
} from '../../plans/legacy-plans/legacy-plans.utility'
import type { PlanSelectionProps } from '../../plans/legacy-plans/legacy-plans.utility'
import type { Plan } from '@flocasts/flosports30-types/dist/subscriptions'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

@Component({
  selector: 'flo-plan-selection-card',
  templateUrl: './plan-selection-card.component.html',
  styleUrls: ['./plan-selection-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanSelectionCardComponent implements OnInit {
  @Input()
  plan: Plan & {
    provider_plan_id: string
    selectionProps: PlanSelectionProps
  }

  /**
   * If a vertical only shows one plan
   */
  @Input()
  hasOneShownPlan: boolean

  /**
   * Current plan selected
   */
  @Input()
  selectedPlan: Plan & {
    provider_plan_id?: string
  }

  /**
   * Reasons to pick this plan
   * ex: 'Stream unlimited events, live or on-demand'
   */
  @Input()
  valueProps: ReadonlyArray<string>

  /**
   * Savings text for one plan over another
   * ex: 'Save $90.00 per year'
   */
  @Input()
  savingsText: string | undefined

  public planTitle: string
  public savings: string
  public label: string
  public billedAsFunnelText: string

  constructor(private readonly productService: ProductService) {}

  ngOnInit() {
    this.setPricingLanguage()
  }

  public planHeaderBannerLanguage: string | undefined

  public periodCostLanguage: string | undefined
  public billedAsLanguage: string | undefined
  public desktopRadioSubHeading: string | undefined
  public mobileRadioSubHeading: string | undefined

  private setPricingLanguage = (): void => {
    this.planHeaderBannerLanguage = buildHeaderBannerLanguage(this.plan.percentage_saved, this.hasOneShownPlan)
    this.periodCostLanguage = buildPeriodCostLanguage(this.plan.selectionProps.displayPriceAnnually, this.plan)
    this.billedAsLanguage = buildBilledAsLanguage(this.plan.yearly)
    this.planTitle = buildPlanTitle(this.plan.yearly)
    this.billedAsFunnelText = getBillingPlanLabel(this.plan)
  }

  public changeSelectedPlan(plan: Plan) {
    this.productService.updateSelectedPlan(plan)
  }

  readonly trackById = trackById
}
